import React, { useState, useContext } from "react";
import DepartmentProcessReadOnlyRow from "./DepartmentProcessReadOnlyRow";
import DepartmentProcessTableRow from "./DepartmentProcessTableRow";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import UserContext from "../contexts/UserContext";

function DepartmentProcesssTable({ setDeptProcess, processTypesForDept, processTypes, companyId, departmentKey, refetch }) {
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [count, setCount] = useState(0);
	const userCtx = useContext(UserContext);

	const closeText = t("page.close");

	const initialValues = {
		companyId: companyId,
		departmentKey: departmentKey,
		processTypeKey: 0,
		processName: "",
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	const handleClose = (event) => {
		setDeptProcess(false);
	};

	const handleDeleteClick = (event, deptProcessItem, completeCallback) => {
		event.preventDefault();
		deleteDeptProcess(deptProcessItem, completeCallback);
	};

	const deleteDeptProcess = (deptProcessItem, completeCallback) => {
		let action = 3;
		if (deptProcessItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			companyId: companyId,
			departmentKey: departmentKey,
			processTypeKey: deptProcessItem.processTypeKey,
			statusCode: deptProcessItem.statusCode,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteDepartmentProcess", "/Service/CompanyService/DeleteDepartmentProcess", requestOptions, deleteDeptProcessSuccess, deleteDeptProcessFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteDeptProcessFail(redirect, completeCallback) {
		setError(t("error.deptProcEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteDeptProcessSuccess(responseData, completeCallback) {
		let deleteDepartmentProcessResponse;
		if (responseData) {
			deleteDepartmentProcessResponse = responseData.deleteDepartmentProcessResponse;
			if (deleteDepartmentProcessResponse) {
				if (deleteDepartmentProcessResponse.errorCode === "0") {
					resetRowTable();
					//setDeptProcess(false);
					resetCounter();
					refetch();
				} else {
					setError(t("error.error") + " " +
						deleteDepartmentProcessResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}

	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};

	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};
	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};

	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.companyId) {
			setError(t("error.companyNameReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (!formValues.departmentKey) {
			setError(t("error.deptNameReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (processTypesForDept.length > 0) {
				processTypesForDept.map((deptProcessItem, idx) => {
					if (deptProcessItem.processTypeKey === setValues.processTypeKey) {
						setError(t("error.deptProcDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveDeptProcess(action, setValues, completeCallback);
			}
		} else {
			saveDeptProcess(action, setValues, completeCallback);
		}
	};
	const saveDeptProcess = (action, setValues, completeCallback) => {
		let serverParams = {
			companyId: formValues.companyId,
			departmentKey: formValues.departmentKey,
			processTypeKey: setValues.processTypeKey,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateDepartmentProcess", "/Service/CompanyService/AddUpdateDepartmentProcess", requestOptions, saveDeptProcessSuccess, saveDeptProcessFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveDeptProcessFail(redirect, completeCallback) {
		setError(t("error.deptProcEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveDeptProcessSuccess(responseData, completeCallback) {
		let addUpdateDepartmentProcessResponse;
		if (responseData) {
			addUpdateDepartmentProcessResponse = responseData.addUpdateDepartmentProcessResponse;
			if (addUpdateDepartmentProcessResponse) {
				if (addUpdateDepartmentProcessResponse.errorCode === "0") {
					resetRowTable();
					//setDeptProcess(false);
					resetCounter();
					refetch();
				} else {
					setError(t("error.error") + " " +
						addUpdateDepartmentProcessResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}

	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="modalContainer hide-scrollbar">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th">{t("page.process")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th">
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add && addRowTop &&
										<DepartmentProcessTableRow
											index={count}
											processTypes={processTypes}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((processTypesForDept.length % 2) > 0) ? true : false} />
									}
									{(processTypesForDept.length > 0) ? (
										processTypesForDept.map((deptProcessItem, index) => (
											<DepartmentProcessReadOnlyRow
												index={count}
												t={t}
												deptProcessItem={deptProcessItem}
												handleDeleteClick={handleDeleteClick}
												oddIdx={((index % 2) > 0) ? true : false}
												add={add}
												setError={setError}
											/>
										))
									) : (<></>)}
									{add && addRowBottom &&
										<DepartmentProcessTableRow
											index={count}
											processTypes={processTypes}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((processTypesForDept.length % 2) > 0) ? true : false} />
									}
								</tbody>
								{(processTypesForDept.length > 10) ? (<tfoot>
									<tr role="row">
										<th className="list-th">{t("page.process")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th">
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</tfoot>
								) : (<></>)}
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-deptproc-close"
									id="edit-deptproc-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default DepartmentProcesssTable;